export default __webpack_public_path__ + "static/media/tattoos.4d6e2aed.svg";